import { render, staticRenderFns } from "./CardList-media.vue?vue&type=template&id=10893fe4&"
import script from "./CardList-media.vue?vue&type=script&lang=js&"
export * from "./CardList-media.vue?vue&type=script&lang=js&"
import style0 from "./CardList-media.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports